const InfoItem = ({
	label,
	value,
	align = "default",
	style = "default",
}: {
	label: string;
	value: string | number | null;
	align?: "default" | "justify";
	style?: "default" | "detail";
}) => {
	if (align === "justify") {
		return (
			<div className="flex w-full items-center justify-between gap-x-[20px] text-[14px]">
				<p className="w-full ">{label}</p>
				{style === "detail" ? (
					<pre className="break-words white-space-pre-wrap font-lao">
						{value || "-"}
					</pre>
				) : (
					<p className="w-full font-bold text-end">{value || "-"}</p>
				)}
			</div>
		);
	}

	return (
		<div className="flex w-full items-center gap-x-[20px] text-[14px]">
			<p className="w-[30%] ">{label}</p>
			{style === "detail" ? (
				<pre className="break-words white-space-pre-wrap w-[70%] font-bold font-lao">
					{value || "-"}
				</pre>
			) : (
				<p className="w-[70%] font-bold">{value || "-"}</p>
			)}
		</div>
	);
};

export default InfoItem;
